"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@formily/shared");
var immer_1 = require("immer");
immer_1.enableAllPlugins();
immer_1.setAutoFreeze(false);
var produce = new immer_1.Immer({
    autoFreeze: false
}).produce;
var applyPatches = function (target, patches) {
    patches.forEach(function (_a) {
        var op = _a.op, path = _a.path, value = _a.value;
        if (op === 'replace' || op === 'add') {
            shared_1.FormPath.setIn(target, path, value);
        }
        else if (op === 'remove') {
            shared_1.FormPath.deleteIn(target, path);
        }
    });
};
exports.createModel = function (Factory) {
    return (function (_super) {
        __extends(Model, _super);
        function Model(props) {
            if (props === void 0) { props = {}; }
            var _this = _super.call(this) || this;
            _this.hasChanged = function (pattern) {
                if (!pattern) {
                    return _this.dirtyCount > 0;
                }
                else {
                    var path = shared_1.FormPath.parse(pattern);
                    if (path.length > 1 || !shared_1.isStr(pattern)) {
                        return !shared_1.isEqual(shared_1.FormPath.getIn(_this.prevState, path), shared_1.FormPath.getIn(_this.state, path));
                    }
                    else {
                        return !!_this.dirtys[pattern];
                    }
                }
            };
            _this.props = shared_1.defaults(Factory.defaultProps, props);
            _this.displayName = Factory.displayName;
            _this.factory = new Factory(_this.props);
            _this.cache = new Map();
            _this.state = _this.factory.state;
            _this.state.displayName = _this.displayName;
            _this.prevState = _this.state;
            _this.batching = false;
            _this.dirtyStack = [];
            _this.dirtyCountStack = [];
            return _this;
        }
        Model.prototype.enterCalculateDirtys = function () {
            this.dirtyStack.push({});
            this.dirtyCountStack.push(0);
        };
        Model.prototype.existCalculateDirtys = function () {
            this.dirtyStack.pop();
            this.dirtyCountStack.pop();
        };
        Object.defineProperty(Model.prototype, "dirtys", {
            get: function () {
                return this.dirtyStack[this.dirtyStack.length - 1] || {};
            },
            set: function (dirtys) {
                if (this.dirtyStack.length === 0) {
                    this.dirtyStack.push({});
                }
                this.dirtyStack[this.dirtyStack.length - 1] = dirtys;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Model.prototype, "dirtyCount", {
            get: function () {
                return this.dirtyCountStack[this.dirtyCountStack.length - 1] || 0;
            },
            set: function (value) {
                if (this.dirtyCountStack.length === 0) {
                    this.dirtyCountStack.push(0);
                }
                this.dirtyCountStack[this.dirtyCountStack.length - 1] = value;
            },
            enumerable: true,
            configurable: true
        });
        Model.prototype.getBaseState = function () {
            if (shared_1.isFn(this.factory.getState)) {
                return this.factory.getState.call(this.factory, this.state);
            }
            else {
                return this.state;
            }
        };
        Model.prototype.getDirtysFromPatches = function (patches, refresh) {
            return patches.reduce(function (buf, _a) {
                var path = _a.path;
                buf[path[0]] = true;
                return buf;
            }, refresh ? {} : this.batching ? this.dirtys : {});
        };
        Model.prototype.dirtyCheck = function (path, nextValue) {
            var currentValue = shared_1.FormPath.getIn(this.state, path);
            if (shared_1.isFn(this.factory.dirtyCheck)) {
                if (shared_1.isFn(this.props.dirtyCheck)) {
                    return (this.factory.dirtyCheck(path, currentValue, nextValue) &&
                        this.props.dirtyCheck(path, currentValue, nextValue));
                }
                else {
                    return this.factory.dirtyCheck(path, currentValue, nextValue);
                }
            }
            else {
                if (shared_1.isFn(this.props.dirtyCheck)) {
                    return this.props.dirtyCheck(path, currentValue, nextValue);
                }
                else {
                    return !shared_1.isEqual(currentValue, nextValue);
                }
            }
        };
        Model.prototype.setState = function (recipe, silent) {
            var _this = this;
            if (silent === void 0) { silent = false; }
            var _a, _b, _c, _d;
            if (!shared_1.isFn(recipe))
                return;
            var base = this.getBaseState();
            this.patches = [];
            this.prevState = base;
            this.factory.prevState = base;
            this.factory.state = base;
            (_b = (_a = this.factory) === null || _a === void 0 ? void 0 : _a.beforeProduce) === null || _b === void 0 ? void 0 : _b.call(_a);
            if (!this.batching) {
                this.enterCalculateDirtys();
            }
            produce(base, function (draft) {
                recipe(draft);
                if (shared_1.isFn(_this.props.computeState)) {
                    _this.props.computeState(draft, _this.prevState);
                }
            }, function (patches) {
                _this.patches = _this.patches.concat(patches);
            });
            var produced = produce(base, function (draft) {
                applyPatches(draft, _this.patches);
                var dirtys = _this.getDirtysFromPatches(_this.patches, true);
                if (shared_1.isFn(_this.factory.produce)) {
                    _this.factory.produce(draft, dirtys);
                }
            }, function (patches) {
                patches.forEach(function (patch) {
                    var path = patch.path, value = patch.value;
                    if (_this.dirtyCheck(path, value)) {
                        _this.patches.push(patch);
                        _this.dirtyCount++;
                    }
                });
            });
            this.factory.state = produced;
            this.state = produced;
            this.dirtys = this.getDirtysFromPatches(this.patches);
            this.patches = [];
            (_d = (_c = this.factory) === null || _c === void 0 ? void 0 : _c.afterProduce) === null || _d === void 0 ? void 0 : _d.call(_c);
            if (this.dirtyCount > 0 && !silent) {
                if (this.batching) {
                    return;
                }
                this.notify(this.getState(), silent);
            }
            this.existCalculateDirtys();
        };
        Model.prototype.setSourceState = function (recipe) {
            if (!shared_1.isFn(recipe))
                return this.state;
            recipe(this.state);
        };
        Model.prototype.getState = function (recipe) {
            if (!shared_1.isFn(recipe))
                return this.getBaseState();
            return recipe(this.getBaseState());
        };
        Model.prototype.getSourceState = function (recipe) {
            if (!shared_1.isFn(recipe))
                return this.state;
            return recipe(this.state);
        };
        Model.prototype.batch = function (callback) {
            this.batching = true;
            this.enterCalculateDirtys();
            var prevState = this.state;
            if (shared_1.isFn(callback)) {
                callback();
            }
            this.prevState = prevState;
            if (this.dirtyCount > 0) {
                this.notify(this.getState());
            }
            this.batching = false;
            this.existCalculateDirtys();
        };
        Model.prototype.setCache = function (key, value) {
            this.cache.set(key, typeof value === 'object' ? shared_1.shallowClone(value) : value);
        };
        Model.prototype.getCache = function (key) {
            var value = this.cache.get(key);
            if (shared_1.isValid(value))
                return value;
            if (this.cache.size === 1) {
                var findKey_1 = null;
                this.cache.forEach(function (value, key) {
                    findKey_1 = key;
                });
                return this.cache.get(findKey_1);
            }
            return value;
        };
        Model.prototype.removeCache = function (key) {
            this.cache.delete(key);
        };
        Model.prototype.isDirty = function (key) {
            if (key) {
                return this.dirtys[key];
            }
            else {
                return this.dirtyCount > 0;
            }
        };
        return Model;
    }(shared_1.Subscribable));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/core/lib/shared/model.js
// module id = 409
// module chunks = 0